import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 2l-.243 .004a7.004 7.004 0 0 0 -6.757 6.996v6a7 7 0 0 0 7 7l.243 -.004a7.004 7.004 0 0 0 6.757 -6.996v-6a7 7 0 0 0 -7 -7z","key":"svg-0"}]]

/**
 * IconCapsuleFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItY2Fwc3VsZSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgMmwtLjI0MyAuMDA0YTcuMDA0IDcuMDA0IDAgMCAwIC02Ljc1NyA2Ljk5NnY2YTcgNyAwIDAgMCA3IDdsLjI0MyAtLjAwNGE3LjAwNCA3LjAwNCAwIDAgMCA2Ljc1NyAtNi45OTZ2LTZhNyA3IDAgMCAwIC03IC03eiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/capsule-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCapsuleFilled = createReactComponent('filled', 'capsule-filled', 'CapsuleFilled', __iconNode);

export default IconCapsuleFilled;